import {AuthApiClient} from "./AuthApiClient";
import {MockAuthApiClient} from "./MockAuthApiClient";
import {FetchAuthApiClient} from "./FetchAuthApiClient";

export default class AuthClientFactory {

    private static instance: AuthApiClient | null = null;

    static getAuthClient(): AuthApiClient {
        if (!this.instance) {
            const isDev = process.env.REACT_APP_USE_MOCK_AUTH === 'true';
            this.instance = isDev  ? new MockAuthApiClient()  : new FetchAuthApiClient();
        }
        return this.instance;
    }

}

